/** スクロール一時禁止 **/
let fixdScrollpos;
export function scrollControlFunk(res) {
  //背景固定
  function controlStop() {
    fixdScrollpos = $(window).scrollTop();
    $('body').addClass('fixedBody').css({
      'top': -fixdScrollpos
    });
  }
  //背景固定解除
  function controlRelease() {
    $('body').removeClass('fixedBody').css({
      'top': 0
    });
    window.scrollTo(0, fixdScrollpos);
  }

  switch (res) {
    case 'stop':
      /*背景固定*/
      controlStop();
      break;
    case 'release':
      /*背景固定解除*/
      controlRelease();
      break;
  }
}

export function fadeInFunc() {
  const options = {
    root: null,
    threshold: 0
  };

  const callback = (function (changes) {
    for (let change of changes) {
      let target = change.target;
      if (change.isIntersecting) {
        target.classList.add('active');
      }
    }
  });

  const observer = new IntersectionObserver(callback, options);

  const targets = document.querySelectorAll('.fadeIn')
  for (let target of targets) {
    observer.observe(target)
  }

  const images = document.querySelectorAll(".lazyload");
  new LazyLoad(images, {
    root: null,
    rootMargin: "0px",
    threshold: 0
  });
}

/** スクロール一時禁止 **/
let scroll_control = function (e) {
  e.preventDefault();
}
export function no_scroll() {
  document.addEventListener("mousewheel", scroll_control, {
    passive: false
  });
  document.addEventListener("touchmove", scroll_control, {
    passive: false
  });
}
export function return_scroll() {
  document.removeEventListener("mousewheel", scroll_control, {
    passive: false
  });
  document.removeEventListener('touchmove', scroll_control, {
    passive: false
  });
}
